(function () {
  function initDeskSelector(selectorEl) {
    var blockId = selectorEl.dataset.blockId;
    var dataEl = document.getElementById('desk-selector-data-' + blockId);
    if (!dataEl) return;

    var desksData = [];
    try {
      desksData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var sizeWrapper = document.getElementById('desk-size-wrapper-' + blockId);
    var currentTextEl = document.getElementById('desk-selector-current-' + blockId);
    var unfitNoticeEl = document.getElementById('desk-selector-unfit-notice-' + blockId);
    var currentDeskSku = '';

    var deskById = {};
    desksData.forEach(function (desk) {
      deskById[String(desk.id)] = desk;
    });

    // ── 自定义下拉组件工厂 ──────────────────────────────────────────────────────
    function createCustomDropdown(wrapperEl) {
      var trigger = wrapperEl.querySelector('.desk-selector__trigger');
      var triggerText = wrapperEl.querySelector('.desk-selector__trigger-text');
      var listbox = wrapperEl.querySelector('.desk-selector__listbox');
      var _value = null;
      var _options = [];
      var _changeCallback = null;

      function open() {
        selectorEl.querySelectorAll('.desk-selector__listbox').forEach(function (l) {
          if (l !== listbox && !l.hasAttribute('hidden')) {
            l.setAttribute('hidden', '');
            var t = l.closest('.desk-selector__select-wrapper').querySelector('.desk-selector__trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        listbox.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        listbox.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
      }

      function selectValue(value, triggerChange) {
        var opt = _options.find(function (o) { return o.value === value; });
        if (!opt) return;
        _value = value;
        triggerText.textContent = opt.text;
        listbox.querySelectorAll('.desk-selector__option').forEach(function (el) {
          el.classList.toggle('is-selected', el.dataset.value === value);
        });
        close();
        if (triggerChange !== false && _changeCallback) {
          _changeCallback(_value);
        }
      }

      function setOptions(options) {
        _options = options;
        _value = null;
        triggerText.textContent = '';
        listbox.innerHTML = '';
        options.forEach(function (opt) {
          var li = document.createElement('li');
          li.className = 'desk-selector__option';
          li.setAttribute('role', 'option');
          li.dataset.value = opt.value;
          li.textContent = opt.text;
          li.addEventListener('click', function () {
            selectValue(opt.value, true);
          });
          listbox.appendChild(li);
        });
      }

      trigger.addEventListener('click', function () {
        if (listbox.hasAttribute('hidden')) { open(); } else { close(); }
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (listbox.hasAttribute('hidden')) { open(); } else { close(); }
        } else if (e.key === 'Escape') {
          close();
          trigger.focus();
        }
      });

      listbox.querySelectorAll('.desk-selector__option').forEach(function (el) {
        _options.push({ value: el.dataset.value, text: el.textContent.trim() });
        el.addEventListener('click', function () {
          selectValue(el.dataset.value, true);
        });
      });

      return {
        get value() { return _value; },
        set value(v) { selectValue(v, false); },
        get options() { return _options; },
        setOptions: setOptions,
        close: close,
        onChange: function (cb) { _changeCallback = cb; }
      };
    }

    document.addEventListener('click', function (e) {
      if (!selectorEl.contains(e.target)) {
        selectorEl.querySelectorAll('.desk-selector__listbox').forEach(function (l) {
          if (!l.hasAttribute('hidden')) {
            l.setAttribute('hidden', '');
            var t = l.closest('.desk-selector__select-wrapper').querySelector('.desk-selector__trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });

    var productWrapper = document.getElementById('desk-product-wrapper-' + blockId);
    var productDropdown = createCustomDropdown(productWrapper);
    var sizeDropdown = createCustomDropdown(sizeWrapper);

    // ── 工具函数 ────────────────────────────────────────────────────────────────

    // 统一 trim + Unicode NFC 规范化，避免特殊字符/不可见空格导致 === 比较失败
    function normalizeStr(s) {
      return s == null ? '' : String(s).normalize('NFC').trim();
    }

    function getUniqueSizeValues(desk) {
      var seen = new Set();
      var result = [];
      var idx = desk.size_option_index || 0;
      (desk.variants || []).forEach(function (v) {
        var raw = v.options && v.options[idx];
        if (raw == null) return;
        var val = normalizeStr(raw);
        if (!seen.has(val)) {
          seen.add(val);
          result.push({ value: val, text: raw });
        }
      });
      return result;
    }

    function findVariantBySize(desk, sizeValue) {
      var variants = desk.variants || [];
      var idx = desk.size_option_index || 0;
      var normalized = normalizeStr(sizeValue);
      var result =
        variants.find(function (v) {
          return v.options && normalizeStr(v.options[idx]) === normalized && v.available;
        }) ||
        variants.find(function (v) {
          return v.options && normalizeStr(v.options[idx]) === normalized;
        });
      return result;
    }

    function updateCurrentLabel() {
      var selectedOpt = productDropdown.options.find(function (o) { return o.value === productDropdown.value; });
      var productTitle = selectedOpt ? selectedOpt.text : '';
      var sizeValue = sizeDropdown.value || '';
      currentTextEl.textContent = productTitle
        ? (sizeValue ? productTitle + ' / ' + sizeValue : productTitle)
        : '';
    }

    function clearUnfitStatus() {
      currentDeskSku = '';
      document.querySelectorAll('.option_wrapper.unfit').forEach(function (el) {
        el.classList.remove('unfit');
      });
      enableAddToCartButtons();
      updateDeskSkuProperty('');
    }

    function updateDeskSkuProperty(sku) {
      window.deskSelectorSku = sku || '';
    }

    // ── 加购按钮置灰 / 恢复 ──────────────────────────────────────────────────────

    function isSkuUnfit(accessorySku, deskSku) {
      if (!accessorySku || !deskSku) return false;
      return (window.unfit_accessories_data || []).some(function (item) {
        return (
          Array.isArray(item.accessories_sku) &&
          item.accessories_sku.includes(accessorySku) &&
          Array.isArray(item.desks_sku) &&
          item.desks_sku.includes(deskSku)
        );
      });
    }

    function getCurrentAccessorySku() {
      if (window.currentVariantSku) return window.currentVariantSku;

      var variantRadios =
        document.querySelector('variant-radios') ||
        document.querySelector('variant-selects');
      if (variantRadios) {
        var scriptEl = variantRadios.querySelector('script[type="application/json"]');
        if (scriptEl) {
          try {
            var variants = JSON.parse(scriptEl.textContent);
            var checkedValues = Array.from(
              variantRadios.querySelectorAll('input[type="radio"]:checked'),
              function (i) { return i.value; }
            );
            if (checkedValues.length > 0) {
              var matched = variants.find(function (v) {
                return v.options.every(function (opt, idx) { return opt === checkedValues[idx]; });
              });
              if (matched && matched.sku) return matched.sku;
            }
            if (variants[0] && variants[0].sku) return variants[0].sku;
          } catch (e) {}
        }
      }

      var productDataEl =
        document.getElementById('product-data') ||
        document.getElementById('product_data');
      if (productDataEl) {
        try {
          var productData = JSON.parse(productDataEl.textContent);
          var sel = productData.selected_or_first_available_variant;
          if (sel && sel.sku) return sel.sku;
        } catch (e) {}
      }

      return '';
    }

    function updateAddToCartUnfitStatus() {
      var sku = getCurrentAccessorySku();
      var isUnfit = currentDeskSku && isSkuUnfit(sku, currentDeskSku);
      document.querySelectorAll('.product-form__submit').forEach(function (btn) {
        btn.classList.toggle('desk-selector-unfit', !!isUnfit);
      });
      if (unfitNoticeEl) {
        unfitNoticeEl.toggleAttribute('hidden', !isUnfit);
      }
    }

    function enableAddToCartButtons() {
      document.querySelectorAll('.product-form__submit.desk-selector-unfit').forEach(function (btn) {
        btn.classList.remove('desk-selector-unfit');
      });
      if (unfitNoticeEl) unfitNoticeEl.setAttribute('hidden', '');
    }

    function setupAddToCartInterceptor() {
      document.querySelectorAll('product-form').forEach(function (pf) {
        pf.addEventListener('submit', function (e) {
          if (currentDeskSku && isSkuUnfit(getCurrentAccessorySku(), currentDeskSku)) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }
        }, true);
      });
    }

    function checkAccessoryUnfitStatus(deskSku) {
      currentDeskSku = deskSku;
      updateDeskSkuProperty(deskSku);
      var unfit_data = window.unfit_accessories_data || [];
      var variantRadios =
        document.querySelector('variant-radios') ||
        document.querySelector('variant-selects');
      if (!variantRadios) return;

      var variantScriptEl = variantRadios.querySelector('script[type="application/json"]');
      if (!variantScriptEl) return;

      var accessoryVariants;
      try {
        accessoryVariants = JSON.parse(variantScriptEl.textContent);
      } catch (e) {
        return;
      }

      variantRadios.querySelectorAll('.option_wrapper').forEach(function (wrapper) {
        var optionFloor = wrapper.dataset.optionFloor;
        var value = wrapper.dataset.value;
        if (!optionFloor || value == null) return;

        var optionIndex = parseInt(optionFloor.replace('option', ''), 10) - 1;
        var matchingVariants = accessoryVariants.filter(function (v) {
          return v.options && v.options[optionIndex] === value;
        });
        if (matchingVariants.length === 0) return;

        var allUnfit = matchingVariants.every(function (v) {
          return unfit_data.some(function (item) {
            return (
              Array.isArray(item.accessories_sku) &&
              item.accessories_sku.includes(v.sku) &&
              Array.isArray(item.desks_sku) &&
              item.desks_sku.includes(deskSku)
            );
          });
        });

        wrapper.classList.toggle('unfit', allUnfit);
      });

      setTimeout(updateAddToCartUnfitStatus, 100);
    }

    // ── 尺寸填充 ─────────────────────────────────────────────────────────────────

    // 优先选中第一个与当前配件可适配的尺寸，避免默认到不适配尺寸影响转化
    function findFirstCompatibleSizeValue(desk, sizes) {
      if (!sizes.length) return null;

      var accessorySku = getCurrentAccessorySku();
      if (!accessorySku) return sizes[0].value;

      for (var i = 0; i < sizes.length; i++) {
        var variant = findVariantBySize(desk, sizes[i].value);
        if (variant && variant.sku && !isSkuUnfit(accessorySku, variant.sku)) {
          return sizes[i].value;
        }
      }

      return sizes[0].value;
    }

    function populateSizes(desk) {
      var sizes = getUniqueSizeValues(desk);
      sizeDropdown.setOptions(sizes.map(function (s) { return { value: s.value, text: s.text }; }));
      if (sizes.length > 0) {
        sizeDropdown.value = findFirstCompatibleSizeValue(desk, sizes);
      }
    }

    // ── 下拉联动事件 ──────────────────────────────────────────────────────────────

    productDropdown.onChange(function (deskId) {
      var desk = deskById[String(deskId)];

      if (desk) {
        populateSizes(desk);
        sizeWrapper.removeAttribute('hidden');
        var sizeValue = sizeDropdown.value;
        if (sizeValue) {
          var variant = findVariantBySize(desk, sizeValue);
          if (variant && variant.sku) {
            checkAccessoryUnfitStatus(variant.sku);
          } else {
            clearUnfitStatus();
          }
        }
      } else {
        sizeDropdown.setOptions([]);
        sizeWrapper.setAttribute('hidden', '');
        clearUnfitStatus();
      }
      updateCurrentLabel();
    });

    sizeDropdown.onChange(function (sizeValue) {
      var desk = productDropdown.value ? deskById[String(productDropdown.value)] : null;
      updateCurrentLabel();
      if (desk && sizeValue) {
        var variant = findVariantBySize(desk, sizeValue);
        if (variant && variant.sku) {
          checkAccessoryUnfitStatus(variant.sku);
        } else {
          clearUnfitStatus();
        }
      } else {
        clearUnfitStatus();
      }
    });

    // ── 初始化 ────────────────────────────────────────────────────────────────────

    function setupVariantChangeListener() {
      var variantRadios =
        document.querySelector('variant-radios') ||
        document.querySelector('variant-selects');
      if (!variantRadios) return;
      variantRadios.addEventListener('change', function () {
        if (currentDeskSku) setTimeout(updateAddToCartUnfitStatus, 0);
      });
    }

    function init() {
      if (desksData.length === 0) return;

      productDropdown.setOptions(desksData.map(function (d) {
        return { value: String(d.id), text: d.title };
      }));

      var firstDesk = desksData[0];
      productDropdown.value = String(firstDesk.id);
      populateSizes(firstDesk);
      sizeWrapper.removeAttribute('hidden');
      updateCurrentLabel();

      var firstSizeValue = sizeDropdown.value;
      var variant = firstSizeValue ? findVariantBySize(firstDesk, firstSizeValue) : null;
      if (variant && variant.sku) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () {
            setupAddToCartInterceptor();
            checkAccessoryUnfitStatus(variant.sku);
            setupVariantChangeListener();
          });
        } else {
          setupAddToCartInterceptor();
          checkAccessoryUnfitStatus(variant.sku);
          setupVariantChangeListener();
        }
      }
    }

    init();
  }

  function mountAll() {
    document.querySelectorAll('.desk-selector[data-block-id]').forEach(initDeskSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
